import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async fecharPedido(axios, parametros) { 
    parametros.operacao = 'fecharPedido';

    let retorno = {};

    await axios.santriPOST('/rest/orcamento', parametros, 600, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
  
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoFecharPedido.js